import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { MortalityModel } from '../models/MortalityModel';
import { URLsConfig } from '../URLsConfig';
import { NurseAssessmentModel, NurseFollowUpModel } from '../models/NurseAssessmentModel';
@Injectable()
export class NurseAssessmentService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    public GetNurseAssessment(PatientCode: string , VisitDate: string) {
      let params = new HttpParams();
        params = params.append("PatientCode", PatientCode);
        params = params.append("VisitDate", VisitDate);
        const options = {
            params: params
        };
        return this.http.get<NurseAssessmentModel>(this.urlsconfig.WebAPIURL_Test + 'api/NurceAssessment/GetNurceAssessment',options);
    }
    public AddNurseAssessment(nurseassessment: NurseAssessmentModel) {

        return this.http.post<NurseAssessmentModel>(this.urlsconfig.WebAPIURL_Test + 'api/NurceAssessment/AddNurceAssessment', nurseassessment);
    }
    public AddNurseFollowUp(nursefollowup: NurseFollowUpModel) {
      console.log("---",nursefollowup)
      return this.http.post<NurseFollowUpModel>(this.urlsconfig.WebAPIURL_Test + 'api/NurseFollowUp/AddNurseFollowUp', nursefollowup);
  }
    public getNurseFollowUp(prepmasterID :string,category:string,prepimportant:string) {

    let params = new HttpParams();

    params = params.append("prepmasterID", prepmasterID);
    params = params.append("category", category);
    params = params.append("prepimportant", prepimportant);
    const options = {
      params: params
    };
    return this.http.get<NurseFollowUpModel>(this.urlsconfig.WebAPIURL_Test + 'api/NurseFollowUp/GetNurseFollowUp', options);
  }
    public getNurseAssessmentLookup(PatientCode :string) {
       let params = new HttpParams();
       params = params.append("PatientCode", PatientCode);

       const options = {
         params: params
       };

       return this.http.get<NurseAssessmentModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/NurceAssessment/GetNurceAssessment_Patient', options);
     }
     public GetProgressStep(PatientCode: string , TrDate: string,TrType) {
      let params = new HttpParams();
        params = params.append("PatientCode", PatientCode);
        params = params.append("TrDate", TrDate);
        params = params.append("TrType", TrType);

        const options = {
            params: params
        };
        return this.http.get<NurseAssessmentModel>(this.urlsconfig.WebAPIURL_Test + 'api/NurceAssessment/GetProgressStep',options);
    }

}
